<template>
  <div class="mb-2 sub-menu">
    <b-button
      :variant="
        $route.meta.navActiveTab == menu.active ? `primary` : `outline-primary`
      "
      v-for="menu in menus"
      :key="`menu-${menu.routeName}`"
      class="mr-1"
      @click="$router.push({ name: menu.routeName })"
    >
      {{ $t(menu.label) }}
    </b-button>
  </div>
</template>

<script>
import { BButton } from "bootstrap-vue";

export default {
  components: {
    BButton,
  },
  data() {
    return {
      menus: [
        {
          routeName: "bet-setting",
          active: "bet-setting",
          label: "breadcrumb.betSetting",
        },
        {
          routeName: "payout-setting",
          active: "payout-setting",
          label: "breadcrumb.payoutSetting",
        },
        {
          routeName: "time-setting",
          active: "time-setting",
          label: "breadcrumb.timeSetting",
        },
        {
          routeName: "list-block-number",
          active: "block-number",
          label: "breadcrumb.blockNumber",
        },
        {
          routeName: "list-allow-number",
          active: "allow-number",
          label: "breadcrumb.allowNumber",
        },
        {
          routeName: "list-sell-out",
          active: "sell-out",
          label: "breadcrumb.sellOut",
        },
      ],
    };
  },
  setup() {},
};
</script>